import { ComponentProps, forwardRef } from 'react';

import { ScrollToTop } from './ScrollToTop';
import * as styles from './styles.css';

export interface FloatingActionButtonProps extends ComponentProps<'button'> {
  scrollToTop?: boolean;
}

export const FloatingActionButton = forwardRef<HTMLButtonElement, FloatingActionButtonProps>(
  (props, ref) => {
    const { children, scrollToTop, ...args } = props;
    return (
      <>
        {scrollToTop && <ScrollToTop />}
        <button ref={ref} className={styles.fab} {...args}>
          {children || (
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M2 12H22M12 22L12 2" stroke="white" strokeWidth="2" strokeLinecap="round" />
            </svg>
          )}
        </button>
      </>
    );
  },
);
